<template>
  <div class="index">
    <!-- 筛选 -->
    <FilterBox
      ref="FilterBox"
      :formItems="formItems"
      :filterForm="filterForm"
      :areaChange="areaChange"
      :filterClick="filterClick"
      :resetClick="resetClick" />
    <!-- 用户操作按钮 -->
    <section class="section-btns">
      <el-button type="" icon="el-icon-view" @click="viewClick" v-if="btnShow.search" :disabled="selectRows.length!==1">查看</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="createClick" v-if="btnShow.create">创建</el-button>
      <el-button type="primary" icon="el-icon-edit" @click="modifyClick" v-if="btnShow.modify" :disabled="selectRows.length!==1">编辑</el-button>
      <el-upload
        :action="importAction"
        accept=".xls,.xlsx" :limit="1" style="margin:0 10px;" :file-list="importFiles"
        :before-upload="beforeImport" :on-success="importSuccess" v-if="btnShow.import">
        <el-button type="success" icon="el-icon-upload2">数据导入</el-button>
      </el-upload>
      <!-- <el-button type="success" icon="el-icon-download" @click="downloadClick">下载模板</el-button> -->
      <el-button type="success" icon="el-icon-download" @click="$refs.DownloadByArea.visible=true">下载模板</el-button>
      <el-button type="success" icon="el-icon-download" @click="exportClick()" v-if="btnShow.export">数据导出</el-button>
      <el-upload
        :action="importAction2"
        accept=".xls,.xlsx" :limit="1" style="margin:0 10px;" :file-list="importFiles"
        :before-upload="beforeImport" :on-success="importSuccess" v-if="btnShow.migration">
        <el-button type="success" icon="el-icon-upload2">数据迁移</el-button>
      </el-upload>
      <el-button type="danger" icon="el-icon-delete" @click="deleteClick" :disabled="selectRows.length<1" v-if="btnShow.delete">删除</el-button>
      <el-button type="" icon="el-icon-setting" @click="assignClick" v-if="btnShow.assign">分配</el-button>
      <el-button type="" icon="el-icon-setting" @click="transferClick" v-if="btnShow.transfer">转移</el-button>
      <el-button type="" icon="el-icon-setting" @click="setSortClick('f')">设置筛选项</el-button>
      <el-button type="" icon="el-icon-setting" @click="setSortClick('t')">设置表格项</el-button>
    </section>
    <!-- 数据表格 -->
    <TableBox
      ref="TableBox"
      :formItems="formItems"
      :tableData="tableData"
      :currentChange="currentChange"
      :selectionChange="selectionChange"
      :expandChange="expandChange"
      :callClick="callClick"
      actionBarWidth="280"
      :pageData="pageData"
      :pageChange="pageChange"
      fixedFirst
    >
      <template #actionBar="scope" >
        <el-button size="mini" plain type="primary" @click.stop.prevent="saveRowClick(scope.row)">保存</el-button>
        <el-button size="mini" plain type="primary" @click.stop.prevent="viewCallsClick(scope.row)">查看通话记录</el-button>
        <!-- <el-button size="mini" plain type="success" @click.stop.prevent="finishCallsClick(scope.row)" v-if="scope.row.status!==1">完成</el-button> -->
      </template>
    </TableBox>

    <DialogForm
      ref="DialogForm"
      :dialogTitle="dialogTitle"
      :action="$api.url_upload_pu"
      :formItems="formItems"
      @submit="formSubmit" />
      <!-- @watchChange="watchChange"
      dialogWidth="1000px" -->

    <DialogSort
      ref="DialogSort"
      :dialogTitle="dialogTitle"
      @submit="sortSubmit" />

    <el-dialog
			title="导入提示"
			:close-on-click-modal="false"
			:visible.sync="isShowImportTip"
      :append-to-body="true"
			width="500px">
      <div v-html="importResult" style="text-align:left"></div>
    </el-dialog>

    <DownloadByArea ref="DownloadByArea" :xlsCode="xlsCode" />

    <el-dialog
      :visible.sync="isShowCallsDialog" :close-on-click-modal="true"
      title="" center width="900px" class="calls-dialog">
      <div class="calls-dialog-content">
        <el-button size="mini" plain type="primary" @click="refreshCallsClick(viewCallsRow)">刷新通话记录</el-button>
        <el-table class="call-table" :data="viewCallsRow.calls" border highlight-current-row>
          
          <el-table-column
            show-overflow-tooltip v-for="(x2,i2) in callsTableHeards" :key="i2"
            :prop="x2.key" :label="x2.label" align="center" width="160"></el-table-column>
          <el-table-column label="操作" min-width="320" align="center">
            <template slot-scope="scope">
              <el-button size="mini" plain type="success" @click="playCallsClick(scope.row.id)">播放</el-button>
              <el-button size="mini" plain type="success" v-if="btnShow.assign" @click="downloadCallsClick(scope.row.id)">下载通话文件</el-button>
              <!-- <el-button size="mini" plain type="success" @click="viewCallsTextClick(scope.row.voiceTextList)">查看通话文本</el-button> -->
            </template>
          </el-table-column>

        </el-table>
        <Pagenation :pageData="viewCallsRow.pageData" @pageChange="e=>pageChange2(e,viewCallsRow)"></Pagenation>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="isShowCallDialog" :close-on-click-modal="true" :show-close="false"
      title="" center width="600px" class="call-dialog">
      <div class="call-dialog-content">
        <div class="call-dialog-content-row" v-for="(x1,i1) in voiceTextList" :key="i1">
          <span class="call-dialog-content-row-label">{{ x1.userName }}：</span>
          <span class="call-dialog-content-row-value">{{ x1.message }}</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="isShowCallDialog=false">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="isShowAssignDialog" close-on-click-modal title="分配" center width="600px" class="assign-dialog">
      <el-form :model="formDataAssign" label-width="120px">
        <el-form-item label="协作人" prop="transferCollaborator">
          <el-select size="mini" v-model="formDataAssign.transferCollaborator" clearable placeholder="请选择协作人" style="width:320px;" filterable>
            <el-option v-for="(x2, i2) in collaborators" :key="i2" :label="x2" :value="x2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分配人数" prop="pageSize">
          <el-input-number size="mini" v-model="formDataAssign.pageSize" :min="0" clearable placeholder="请填写人数" style="width:320px;" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="assignDialogSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="isShowTransferDialog" close-on-click-modal title="转移" center width="600px" class="assign-dialog">
      <el-form :model="formDataTransfer" label-width="120px">
        <el-form-item label="负责人" prop="transferDirector">
          <el-select size="mini" v-model="formDataTransfer.transferDirector" clearable placeholder="请选择负责人" style="width:320px;" filterable>
            <el-option v-for="(x2, i2) in directors" :key="i2" :label="x2" :value="x2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="转移人数" prop="pageSize">
          <el-input-number size="mini" v-model="formDataTransfer.pageSize" :min="0" clearable placeholder="请填写人数" style="width:320px;" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="transferDialogSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import FilterBox from '@/components/XY/FilterBox'
import TableBox from '@/components/XY/TableBox'
import DialogSort from '@/components/XY/DialogSort'
import DialogForm from '@/components/XY/DialogForm'
// import AreaPicker from '@/components/AreaPicker_3'
import AreaPicker from '@/components/AreaPicker'
import Pagenation from '@/components/Pagenation'
import DownloadByArea from '@/components/DownloadByArea'
import mixin_upload from '@/Mixins/mixin_upload'
import mixin_table from '@/Mixins/mixin_table'
import mixin_tccc from './mixin_tccc'
import { powerMap } from '@/publicData/powerData'

const OPTIONS = {
  stayHospitalDuration: ['短期住院','长期住院','死亡'],
  stayHospitalDuration2: ['短期住院','长期住院','死亡','空'],
  satisfy: ['是','否'],
  satisfy2: ['是','否','空'],
  monthRemarks: ['2025年01月','2025年02月','2025年03月','2025年04月','2025年05月','2025年06月','2025年07月','2025年08月','2025年09月','2025年10月','2025年11月','2025年12月','2026年01月','2026年02月','2026年03月','2026年04月','2026年05月','2026年06月','2026年07月','2026年08月','2026年09月','2026年10月','2026年11月','2026年12月','2027年01月','2027年02月','2027年03月','2027年04月','2027年05月','2027年06月','2027年07月','2027年08月','2027年09月','2027年10月','2027年11月','2027年12月','2028年01月','2028年02月','2028年03月','2028年04月','2028年05月','2028年06月','2028年07月','2028年08月','2028年09月','2028年10月','2028年11月','2028年12月',],
  callStatus: ['未处理','接受回访','拒绝回访','拒绝评分','电话不通或不接电话','错号或空号','关机或停机','死亡','语言不通','不了解情况，未提供有效号码','有隐患，不拨打'],
  callingCount: ['1次','2次','3次'],
  callingCount2: ['1次','2次','3次','空'],
  restoreStatus: ['好','不好'],
  departmentCalling: ['已回访','未回访'],
  bedNotice: ['已告知','未告知'],
  noticeNurse: ['已责任护士告知','未责任护士告知'],
  noticeOperate: ['已操作告知','未操作告知'],
  discountCash: ['是','否'],
  satisfyScore: [{label:'1分',value:1},{label:'2分',value:2},{label:'3分',value:3},{label:'4分',value:4},{label:'5分',value:5},{label:'6分',value:6},{label:'7分',value:7},{label:'8分',value:8},{label:'9分',value:9},{label:'10分',value:10}],
  praiseGroup: ['表扬全体医护','表扬全体医生','表扬全体护士','无表扬全体'],
  criticizeGroup: ['批评全体医护','批评全体医生','批评全体护士','无批评全体'],
  satisfyNurseOrNot: ['有最满意医生护士','无最满意医生护士'],
  followStatus: ['成交'],
  checkInAssess: ['是','否'],
  director: ['邓晓梅','李晓红','杨阳','张如意','魏倩','黄丹','向雪','黄梦琦','殷悦','杨汶涓','辜诗涵'],
  collaborator: ['邓晓梅','李晓红','杨阳','张如意','魏倩','黄丹','向雪','黄梦琦','殷悦','杨汶涓','辜诗涵'],
  collaborator2: ['邓晓梅','李晓红','杨阳','张如意','魏倩','黄丹','向雪','黄梦琦','殷悦','杨汶涓','辜诗涵','空'],
  checkInConvenient: ['是','否'],
  thirdPartContactFamilyMember: ['否','需进一步追踪识别'],
  status: [{label:'完成',value:1},{label:'未处理',value:0}],
}

export default {
  mixins: [mixin_table, mixin_upload, mixin_tccc],
  components: { FilterBox, TableBox, DialogSort, AreaPicker, DialogForm, Pagenation, DownloadByArea },
  data() {
    return {
      sign: 'yiliaofuwu_bqhf',
      dialogTitle: '病人回访信息',
      // fileName: 'qiyexinxi',
      xlsCode: '64',
      importTipKey: 'idNo',
      importTiplabel: '身份证号',
      // filterForm: {
      //   contract: {}
      // }, // 特殊

      baseInfo: [],
      formItems: [
        {
          tType:'xy_text',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_text',fHide:true,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_text',eHide:true,
          vType:'xy_text',vHide:true,
          label:'省',key:'province',
        }, {
          tType:'xy_text',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_text',fHide:true,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_text',eHide:true,
          vType:'xy_text',vHide:true,
          label:'市',key:'city',
        }, {
          tType:'xy_text',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_text',fHide:true,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_text',eHide:true,
          vType:'xy_text',vHide:true,
          label:'县',key:'county',
        }, {
          tType:'xy_text',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_text',fHide:true,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_text',eHide:true,
          vType:'xy_text',vHide:true,
          label:'镇',key:'town',
        }, {
          tType:'xy_text',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_text',fHide:true,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_text',eHide:true,
          vType:'xy_text',vHide:true,
          label:'村',key:'village',
        }, {
          tType:'xy_text',tHide:true,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_text',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_text',eHide:false,
          vType:'xy_input',vHide:false,
          label:'地区',key:'fixed-area',
        }, {
          tType:'xy_text',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_input',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_input',eHide:false,
          vType:'xy_input',vHide:false,
          label:'住院号',key:'bedNo',
        }, {
          tType:'xy_input',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_input',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_input',eHide:false,
          vType:'xy_input',vHide:false,
          label:'身份证号',key:'idNo',
        }, {
          tType:'xy_text',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_input',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_input',eHide:false,
          vType:'xy_input',vHide:false,
          label:'姓名',key:'name',
        }, {
          tType:'xy_text',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_input',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_input',eHide:false,
          vType:'xy_input',vHide:false,
          label:'性别',key:'sex',
        }, {
          tType:'xy_text',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_input',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_number',eHide:false,
          vType:'xy_input',vHide:false,
          label:'年龄',key:'age',
        }, {
          tType:'xy_text',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_input',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_input',eHide:false,
          vType:'xy_input',vHide:false,
          label:'住院科室',key:'inpatientDepartment',
        }, {
          tType:'xy_text',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_date',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_date',eHide:false,
          vType:'xy_date',vHide:false,
          label:'入院时间',key:'enterTime',
        }, {
          tType:'xy_text',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_daterange',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_date',eHide:false,
          vType:'xy_date',vHide:false,
          label:'出院时间',key:'exitTime',
        }, {
          tType:'xy_text',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_number',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_number',eHide:false,
          vType:'xy_input',vHide:false,
          label:'住院天数',key:'stayHospitalDay',
        }, {
          tType:'xy_phone',tHide:false,tChecked:false,tShow:false,tIndex:-1,tDisabled:true,
          fType:'xy_input',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_input',eHide:false,
          vType:'xy_phone',vHide:false,
          label:'联系电话',key:'telephone',
          phoneShow:this.phoneShow,
        }, {
          tType:'xy_phone',tHide:false,tChecked:false,tShow:false,tIndex:-1,tDisabled:true,
          fType:'xy_input',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_input',eHide:false,
          vType:'xy_phone',vHide:false,
          label:'电话',key:'phone',
          phoneShow:this.phoneShow,
        }, {
          tType:'xy_text',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_input',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_input',eHide:false,
          vType:'xy_input',vHide:false,
          label:'住院医生',key:'doctor',
        }, {
          tType:'xy_text',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_input',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_input',eHide:false,
          vType:'xy_input',vHide:false,
          label:'诊疗组长',key:'doctorLeader',
        }, {
          tType:'xy_text',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_select',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_select',eHide:false,
          vType:'xy_select',vHide:false,
          label:'住院时长',key:'stayHospitalDuration',options:OPTIONS.stayHospitalDuration,fOptions:OPTIONS.stayHospitalDuration2,
        }, {
          tType:'xy_text',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_select',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_select',eHide:false,
          vType:'xy_select',vHide:false,
          label:'满意度测评',key:'satisfy',options:OPTIONS.satisfy,fOptions:OPTIONS.satisfy2,
        }, {
          tType:'xy_text',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_select',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_select',eHide:false,
          vType:'xy_select',vHide:false,
          label:'月份备注',key:'monthRemarks',options:OPTIONS.monthRemarks,
        }, {
          tType:'xy_select',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_select',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_select',eHide:false,
          vType:'xy_select',vHide:false,
          label:'回访状态',key:'callStatus',options:OPTIONS.callStatus,
        }, {
          tType:'xy_select',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_select',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_select',eHide:false,
          vType:'xy_select',vHide:false,
          label:'回访次数',key:'callingCount',options:OPTIONS.callingCount,fOptions:OPTIONS.callingCount2,
        }, {
          tType:'xy_select',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_select',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_select',eHide:false,
          vType:'xy_select',vHide:false,
          label:'出院后恢复情况',key:'restoreStatus',options:OPTIONS.restoreStatus,
        }, {
          tType:'xy_select',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_select',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_select',eHide:false,
          vType:'xy_select',vHide:false,
          label:'科室是否回访',key:'departmentCalling',options:OPTIONS.departmentCalling,
        }, {
          tType:'xy_select',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_select',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_select',eHide:false,
          vType:'xy_select',vHide:false,
          label:'是否入院告知',key:'bedNotice',options:OPTIONS.bedNotice,
        }, {
          tType:'xy_select',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_select',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_select',eHide:false,
          vType:'xy_select',vHide:false,
          label:'是否告知管床护士',key:'noticeNurse',options:OPTIONS.noticeNurse,
        }, {
          tType:'xy_select',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_select',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_select',eHide:false,
          vType:'xy_select',vHide:false,
          label:'是否操作告知',key:'noticeOperate',options:OPTIONS.noticeOperate,
        }, {
          tType:'xy_select',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_select',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_select',eHide:false,
          vType:'xy_select',vHide:false,
          label:'是否收受红包回扣',key:'discountCash',options:OPTIONS.discountCash,
        }, {
          tType:'xy_select',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_select',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_select',eHide:false,
          vType:'xy_select',vHide:false,
          label:'回访满意度评分',key:'satisfyScore',options:OPTIONS.satisfyScore,
        }, {
          tType:'xy_select',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_select',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_select',eHide:false,
          vType:'xy_select',vHide:false,
          label:'表扬集体',key:'praiseGroup',options:OPTIONS.praiseGroup,
        }, {
          tType:'xy_select',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_select',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_select',eHide:false,
          vType:'xy_select',vHide:false,
          label:'批评集体',key:'criticizeGroup',options:OPTIONS.criticizeGroup,
        }, {
          tType:'xy_select',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_select',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_select',eHide:false,
          vType:'xy_select',vHide:false,
          label:'满意或不满意医生护士',key:'satisfyNurseOrNot',options:OPTIONS.satisfyNurseOrNot,
        }, {
          tType:'xy_input',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_input',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_input',eHide:false,
          vType:'xy_input',vHide:false,
          label:'意见建议',key:'suggestion',
        }, {
          tType:'xy_input',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_input',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_input',eHide:false,
          vType:'xy_input',vHide:false,
          label:'住院时间短的原因',key:'shortBedReason',
        }, {
          tType:'xy_input',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_input',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_input',eHide:false,
          vType:'xy_input',vHide:false,
          label:'最满意医生',key:'satisfyDoctor',
        }, {
          tType:'xy_input',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_input',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_input',eHide:false,
          vType:'xy_input',vHide:false,
          label:'最满意护士',key:'satisfyNorse',
        }, {
          tType:'xy_input',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_input',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_input',eHide:false,
          vType:'xy_input',vHide:false,
          label:'最不满意医生',key:'unsatisfiedDoctor',
        }, {
          tType:'xy_input',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_input',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_input',eHide:false,
          vType:'xy_input',vHide:false,
          label:'最不满意护士',key:'unsatisfiedNorse',
        }, {
          tType:'xy_select',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_select',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_select',eHide:false,
          vType:'xy_select',vHide:false,
          label:'跟进状态',key:'followStatus',options:OPTIONS.followStatus
        }, {
          tType:'xy_text',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_select',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_select',eHide:false,
          vType:'xy_select',vHide:false,
          label:'是否参与测评',key:'checkInAssess',options:OPTIONS.checkInAssess
        }, {
          tType:'xy_date',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_date',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_date',eHide:false,
          vType:'xy_date',vHide:false,
          label:'下次跟进时间',key:'followUpTime',
        }, {
          tType:'xy_select',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_select',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_select',eHide:false,
          vType:'xy_select',vHide:false,
          label:'负责人',key:'director',options:OPTIONS.director,
        }, {
          tType:'xy_select',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_select',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_select',eHide:false,
          vType:'xy_select',vHide:false,
          label:'协作人',key:'collaborator',options:OPTIONS.collaborator,fOptions:OPTIONS.collaborator2,
        }, {
          tType:'xy_input',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_input',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_input',eHide:false,
          vType:'xy_input',vHide:false,
          label:'联系人姓名',key:'familyMemberName',
        }, {
          tType:'xy_phone',tHide:false,tChecked:false,tShow:false,tIndex:-1,tDisabled:true,
          fType:'xy_input',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_input',eHide:false,
          vType:'xy_phone',vHide:false,
          label:'联系人电话',key:'familyMemberTelephone',
          phoneShow:this.phoneShow,
        }, {
          tType:'xy_phone',tHide:false,tChecked:false,tShow:false,tIndex:-1,tDisabled:true,
          fType:'xy_input',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_input',eHide:false,
          vType:'xy_phone',vHide:false,
          label:'联系人手机',key:'familyMemberPone',
          phoneShow:this.phoneShow,
        }, {
          tType:'xy_input',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_input',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_input',eHide:false,
          vType:'xy_input',vHide:false,
          label:'备注',key:'remarks',
        }, {
          tType:'xy_phone',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_input',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_input',eHide:false,
          vType:'xy_input',vHide:false,
          label:'呼入手机号',key:'callingPhone',
          phoneShow:this.phoneShow,
        // }, {
        //   tType:'xy_text',tHide:true,tChecked:false,tShow:false,tIndex:-1,
        //   fType:'xy_select',fHide:false,fChecked:false,fShow:false,fIndex:-1,
        //   eType:'xy_text',eHide:true,
        //   vType:'xy_text',vHide:true,
        //   label:'状态',key:'status',options:OPTIONS.status
        // }, {
        //   tType:'xy_text',tHide:false,tChecked:false,tShow:false,tIndex:-1,
        //   fType:'xy_daterange',fHide:false,fChecked:false,fShow:false,fIndex:-1,
        //   eType:'xy_date',eHide:true,
        //   vType:'xy_date',vHide:true,
        //   label:'完成时间',key:'statusCompleteTime',
        }, {
          tType:'xy_select',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_select',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_select',eHide:false,
          vType:'xy_select',vHide:false,
          label:'办理手续过程是否及时方便',key:'checkInConvenient',options:OPTIONS.checkInConvenient
        }, {
          tType:'xy_select',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_select',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_select',eHide:false,
          vType:'xy_select',vHide:false,
          label:'是否有第三方人员就后事办理联系家属',key:'thirdPartContactFamilyMember',options:OPTIONS.thirdPartContactFamilyMember
        }, {
          tType:'xy_text',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_text',fHide:true,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_text',eHide:false,cHide:true,
          vType:'xy_text',vHide:false,
          label:'呼叫时长',key:'callDurationDate',
        }, {
          tType:'xy_text',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_daterange',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_date',eHide:true,
          vType:'xy_date',vHide:true,
          label:'更新时间',key:'updateTime',
        },
      ],
      // watchChangeKey: ['buyType'],
      // defaultKeyValue: {
      //   buyType: 1
      // },
      // userList: [],

      viewCallsRow: {},
      isShowCallsDialog: false,
      isShowCallDialog: false,
      checkedCallRow: null,
      callsTableHeards: [
        { key: 'callingDate', label: '呼叫时间' },
        { key: 'durationStr', label: '通话时长' },
        { key: 'phoneStr', label: '被叫号码' },
      ],

      // 迁移
      importFiles: [],

      voiceTextList: [],

      // 播放mp3
      isPlaying: false,
      audioId: '',
      audioUrl: '',
      myAudio: null,

      // 排序
      sortFilterKey: 'followupSearchConfig',
      sortTableKey: 'followupTableConfig',

      // 分配
      collaborators: OPTIONS.collaborator2,
      isShowAssignDialog: false,
      filterFormDataAssign: {},
      formDataAssign: {
        transferCollaborator: '',
        pageSize: '',
      },

      // 转移
      directors: OPTIONS.director,
      isShowTransferDialog: false,
      filterFormDataTransfer: {},
      formDataTransfer: {
        transferDirector: '',
        pageSize: '',
      },
    }
  },
  computed: {
    importAction() {
      // return this.$api.baseUrl + '/user/sync/company/' + this.userInfo.areaId
      return this.$api.baseUrl + '/user/followup/calling/import/excel'
    },
    importAction2() {
      return this.$api.baseUrl + '/user/followup/calling/migration'
    },
  },
  methods: {
    phoneShow(row) {
      const FLAG1 = row.satisfy === '是'
      const powerList = this.userInfo.privilegesList
      const powerStr = powerMap[this.sign]
      const FLAG2 = powerList.includes(powerStr + '-assign')
      return FLAG1 || FLAG2
    },

    // #region 分配
    assignClick() {
      const rD = this.getFilterData()
      if (!rD) return
      delete rD.pageNumber
      this.filterFormDataAssign = rD
      this.isShowAssignDialog = true
    },
    assignDialogSubmit() {
      console.log(this.formDataAssign)
      this.$api.assignPersonCount({
        ...this.filterFormDataAssign,
        ...this.formDataAssign,
      }).then(res => {
        if (res.data.status == 0) {
          this.$message.success('分配成功！')
          this.isShowAssignDialog = false
          this.formDataAssign.transferCollaborator = ''
          this.formDataAssign.pageSize = ''
          this.searchHandler()
        } else { this._status(res.data) }
      })
    },
    // #endregion

    // #region 转移
    transferClick() {
      const rD = this.getFilterData()
      if (!rD) return
      delete rD.pageNumber
      this.filterFormDataTransfer = rD
      this.isShowTransferDialog = true
    },
    transferDialogSubmit() {
      console.log(this.formDataTransfer)
      this.$api.transferPersonCount({
        ...this.filterFormDataTransfer,
        ...this.formDataTransfer,
      }).then(res => {
        if (res.data.status == 0) {
          this.$message.success('转移成功！')
          this.isShowTransferDialog = false
          this.formDataTransfer.transferDirector = ''
          this.formDataTransfer.pageSize = ''
          this.searchHandler()
        } else { this._status(res.data) }
      })
    },
    // #endregion

    // filterClickBefore() {},
    // createClickBefore() {},
    // modifyClickBefore() {},
    // viewClickBefore() {},
    // watchChange(data) {},
    saveRowClick(result) {
      this.selectData = this.tableDataCopy.find(e => e.id === result.id)
      this.isCreate = false
      this.formSubmit(result)
    },
    formSubmit(result) {
      console.log(`%cresult:`, 'color: #00f;', result)
      const mapList = this.formItems.map(e => e.key)
      const rData = {}

      if (!result.bedNo) { this.$message.warning('请填写住院号') }
      // else if (!result.idNo) { this.$message.warning('请填写身份证号码') }
      else if (!result.name) { this.$message.warning('请填写姓名') }
      else if (this.isCreate) {
        mapList.forEach(x => {
          rData[x] = result[x]
        })

        console.log(1111111, rData)
        
        this.$api.util_create(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('创建成功！')
            this.$refs.DialogForm.isShowDialog = false
            this.$refs.DialogForm.clearClick()
            this.searchHandler()
          } else { this._status(res.data) }
        })
      }

      else {
        mapList.forEach(x => {
          if (this.selectData[x] !== result[x]) {
            rData[x] = result[x]
          }
        })
        rData.id = this.selectData.id // 绑定修改的数据id
        console.log(rData)

        this.$api.util_modify(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('修改成功！')
            this.$refs.DialogForm.isShowDialog = false
            this.$refs.DialogForm.clearClick()
            this.searchHandler()
          } else { this._status(res.data) }
        })
      }
    },
    getData(rD = {}) {
      return this.$api.util_search(this.sign, rD).then(res => {
        if (res.data.status == 0) {
          const _R = JSON.parse(res.data.data)
          console.log(`%c_R:`, 'color: #f00;', _R)
          this.tableData = _R.map(x1 => {
            x1.enterTime = new Date(x1.enterTime).getTime()
            x1.exitTime = new Date(x1.exitTime).getTime()
            x1.followUpTime = new Date(x1.followUpTime).getTime()
            // if (x1.satisfy !== '是') {
            //   x1.telephone = this.$t.toHidePhone(x1.telephone)
            //   x1.phone = this.$t.toHidePhone(x1.phone)
            //   x1.familyMemberTelephone = this.$t.toHidePhone(x1.familyMemberTelephone)
            //   x1.familyMemberPone = this.$t.toHidePhone(x1.familyMemberPone)
            //   // x1.callingPhone = this.$t.toHidePhone(x1.callingPhone)
            // }
            x1._telephone = this.$t.toHidePhone(x1.telephone)
            x1._phone = this.$t.toHidePhone(x1.phone)
            x1._familyMemberTelephone = this.$t.toHidePhone(x1.familyMemberTelephone)
            x1._familyMemberPone = this.$t.toHidePhone(x1.familyMemberPone)
            x1._callingPhone = this.$t.toHidePhone(x1.callingPhone)
            x1.pageData = {
              currentPage: 1,
              pageSize: 40,
              total: 0,
            }
            x1.calls = []
            return x1
          })
          return res
        } else { this._status(res.data) }
      })
    },

    // #region 呼叫
    // 点击呼叫
    async callClick(phoneNumber, rowId) {
      if (!this.userInfo.seatUserId) {
        this.$message.error('当前账号没有配置座席数据！');
        return
      }
      if (!window.tccc) {
        this.$message.error('腾讯云TCCC初始化失败！');
        return
      }
      console.log(phoneNumber, rowId)
      if (!phoneNumber) return
      const isBrowserSupported = window.tccc.Devices.isBrowserSupported()
      if (!isBrowserSupported) {
        this.$message.error('当前浏览器不支持网页呼叫！');
        return
      }
      const microphones = await window.tccc.Devices.getMicrophones()
      if (!microphones.length) {
        this.$message.error('没有检测到麦克风设备！')
        return
      }
      const speakers = await window.tccc.Devices.getSpeakers()
      if (!speakers.length) {
        this.$message.error('没有检测到扬声器设备！')
        return
      }
      const res = await window.tccc.Call.startOutboundCall({ phoneNumber })
      this.saveRowData(rowId, phoneNumber)

      console.log('res', res)
    },
    // 展开
    expandChange(row, list) {
      // console.log(row, list)
      // const isExpanded = list.includes(row)
      // const rowId = row.id
      // console.log(rowId, isExpanded)
      // if (isExpanded) {
      //   this.refreshCallsClick(row)
      // }
    },
    // 查看通话记录
    viewCallsClick(row) {
      // this.$refs.TableRef.toggleRowExpansion(row, true)
      this.viewCallsRow = row
      this.isShowCallsDialog = true
      this.refreshCallsClick(row)
    },
    // 完成回访
    // finishCallsClick(row) {
    //   this.$api.util_modify(this.sign, { id: row.id, status: 1 }).then(res => {
    //     if (res.data.status == 0) {
    //       row.status = 1
    //     } else { this._status(res.data) }
    //   })
    // },
    // 刷新通话记录
    refreshCallsClick(row) {
      console.log('刷新通话记录', row)
      row.pageData.currentPage = 1
      this.getCalls(row)
    },
    pageChange2(pageNumer, row) {
      row.pageData.currentPage = pageNumer
      this.getCalls(row)
    },
    // 获取通话记录
    getCalls(row) {
      const rD = { id: row.id, pageNumber: row.pageData.currentPage }
      this.$api.getAllCallHistory(rD).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c列表数据:`, 'color: #f00;', _R)
          this.viewCallsRow.calls = _R.map(x1 => {
            x1.durationStr = x1.duration + '秒'
            x1.phoneStr = this.$t.toHidePhone(x1.phone)
            return x1
          })
          row.pageData.currentPage++
          row.pageData.total = res.data.size
        } else { this._status(res.data) }
      })
    },
    // 播放通话记录
    playCallsClick(id) {
      console.log('playCallsClick')
      if (this.audioId === id && this.audioUrl) {
        this.playAudio(this.audioUrl)
        return
      }
      this.audioId = id
      this.$api.downloadCallHistory({ id }).then(res => {
        if (res.data.status == 0) {
          let _R = res.data.data
          console.log(`%c音频url:`, 'color: #f00;', _R)
          _R && this.playAudio(_R)
        } else { this._status(res.data) }
      })
    },
    // 播放函数
    playAudio(url) {
      if (this.audioUrl !== url) {
        this.audioUrl = url
        this.myAudio && this.myAudio.pause()
        this.isPlaying = false
        this.myAudio = new Audio(url)
        console.log(this.myAudio)
      }
      this.isPlaying = !this.isPlaying
      if (this.isPlaying) {
        this.myAudio.play()
        this.palyEnd()
      } else {
        this.myAudio.pause()
        this.palyEnd()
      }
    },
    palyEnd() {
      this.myAudio.addEventListener('ended', () => {
        this.isPlaying = false
      })
    },
    // 下载通话记录
    downloadCallsClick(id) {
      console.log('downloadCallsClick')
      if (!this.btnShow.assign) return
      this.$api.downloadCallHistory({ id }).then(res => {
        if (res.data.status == 0) {
          let _R = res.data.data
          console.log(`%c音频url:`, 'color: #f00;', _R)
          _R && this.downloadFun2(_R)
        } else { this._status(res.data) }
      })
    },
    // 下载函数
    downloadFun2(url) {
      var a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.download = true
      // a.target = '_blank'
      document.body.appendChild(a)
      a.click()
    },
    // 查看通话文本
    // viewCallsTextClick(list) {
    //   console.log(list)
    //   if (list && list.length) {
    //     this.voiceTextList = list
    //     this.isShowCallDialog = true
    //   }
    // },
    // #endregion

  },
  created() {
    const powerList = this.userInfo.privilegesList
    const powerStr = powerMap[this.sign]
    // const powerStr = powerMap[this.catalog]
    // console.log(powerStr)
    // this.btnShow.search = true
    const mapList = ['search','create','modify','delete','import','export','migration','assign','transfer']
    // const mapList = ['create','modify','delete','import','export']
    if (this.userInfo.admin) {
      mapList.forEach(x => {
        this.btnShow[x] = true
      })
    } else {
      mapList.forEach(x => {
        if (x && powerList.includes(powerStr + '-' + x)) {
          this.btnShow[x] = true
        }
      })
    }
    const { followupSearchConfig, followupTableConfig } = this.userInfo
    followupSearchConfig && this.fillSortItems(followupSearchConfig, 'f')
    followupTableConfig && this.fillSortItems(followupTableConfig, 't')
    console.log(this.formItems)
  },
}
</script>

<style lang='scss' scoped>
.section-btns{padding-left: 15px;margin-right: 10px;display: flex;}
/deep/.section-btns .el-upload-list{display: none;}

.calls-dialog{
  /deep/.el-dialog{
    max-height: 820px !important;
    margin-top: 5vh !important;
  }
  &-content{
    max-height: 670px !important;
    overflow: auto;
    .call-table{
      margin-top: 8px;
    }
  }
}

.call-dialog{
  /deep/.el-dialog{
    max-height: 600px !important;
    margin-top: 15vh !important;
  }
  &-content{
    max-height: 450px !important;
    overflow: auto;
    &-row{
      display: flex;margin-bottom: 10px;
      &-label{flex-shrink: 0;}
    }
  }
}

.assign-dialog{
  /deep/.el-dialog{
    max-height: 280px !important;
    margin-top: 15vh !important;
  }
}
</style>